// eslint-disable-next-line import/prefer-default-export
export const black = "#000";

export const APP_THEMES = {
  TRANSPARENT: "transparent",
  WHITE: "white",
  DARK: "#181818",
};
